<template>
  <div class="pax-box">
    <div class="d-flex justify-space-between align-center pax-head">
      <div class="page-title">
        Passenger Details
        <!-- <span v-if="bookingAsGuest">(Booking as guest)</span> -->
      </div>
      <div class="logout-box" v-if="(user.token && !cardsLoading) || bookingAsGuest">
        <div v-if="bookingAsGuest">
          Continue as guest or
          <a @click="guestLogin">Login</a>
          <!-- Don't have an account?
          <a @click="initShowSignup">Sign up</a> -->
        </div>
        <div v-else>
          Welcome <b >{{user.firstName}}</b>.
          <a @click="logout">Logout</a>
        </div>
      </div>
    </div>
    <div class="pax-copy">
      Please enter the details of the passenger who will be taking 
      the flight. Ensure that the information is accurate and 
      corresponds to the travel documents of the individual traveling.
    </div>

    <div v-if="renderPax || bookingAsGuest">
      <div :class="['pax-form', {'need-auth':showAuthBox && !bookingAsGuest}]" v-for="(pax, p) in paxForm.adult" :key="p">
        <div class="blocker"></div>
        <div class="pax-id d-flex align-center">
          <b>Adult {{ p + 1 }}</b>
          <label class="for-someone" v-if="p === 0 && !bookingAsGuest">
            <input type="checkbox" v-model="forSomeoneElse" @change="toggleForSomeone" />
            <span>Book for someone else.</span>
          </label>
        </div>

        <div class="pax-basic-info align-start">
          <div>
            <div class="pax-field-label">Title<span>*</span></div>
            <select v-model="pax[`title${p}`]" @change="highlightCheck"
              :class="['pax-title no-outline', {'has-error':paxErrorFields.adult.indexOf(`title${p}`) > -1, active: highlight.active === `adult-title${p}`}]">
              <option value="">--</option>
              <option value="Mr">Mr.</option>
              <option value="Ms">Ms.</option>
              <option value="Mrs">Mrs.</option>
              <option value="Miss">Miss</option>
              <option value="Mstr">Mstr</option>
            </select>
          </div>
          <div :class="['pax-field', {'has-error':paxErrorFields.adult.indexOf(`firstName${p}`) > -1}]">
            <div class="pax-field-label">First name<span>*</span></div>
            <input type="text" placeholder="First Name"
              v-model="pax[`firstName${p}`]" @change="gtagTrackPax('firstName', 'adult', p)"
              :class="['no-outline', {active: highlight.active === `adult-firstName${p}`}]" />
          </div>
          <div class="pax-field">
            <div class="pax-field-label">Middle name</div>
            <input type="text" placeholder="Middle Name (Optional)" class="no-outline"
              v-model="pax[`middleName${p}`]" @change="gtagTrackPax('middleName', 'adult', p)"/>
          </div>
          <div :class="['pax-field', {'has-error':paxErrorFields.adult.indexOf(`lastName${p}`) > -1}]">
            <div class="pax-field-label">Last name<span>*</span></div>
            <input type="text" placeholder="Last Name"
              v-model="pax[`lastName${p}`]" @change="gtagTrackPax('lastName', 'adult', p)"
              :class="['no-outline', {active: highlight.active === `adult-lastName${p}`}]" />
          </div>
          <div>
            <div class="pax-field-label">Suffix</div>
            <select class="pax-title no-outline" v-model="pax[`suffix${p}`]">
              <option value="">--</option>
              <option value="Jr">Jr</option>
              <option value="SR">SR</option>
              <option value="II">II</option>
              <option value="III">III</option>
              <option value="IV">IV</option>
            </select>
          </div>
          <div>
            <div class="pax-field-label">Gender<span>*</span></div>
            <select :class="['pax-title no-outline', {'has-error':paxErrorFields.adult.indexOf(`gender${p}`) > -1, active: highlight.active === `adult-gender${p}`}]"
              v-model="pax[`gender${p}`]" @change="gtagTrackPax('gender', 'adult', p)">
              <option value="">--</option>
              <option value="1">Male</option>
              <option value="2">Female</option>
            </select>
          </div>
        </div>

        <div class="row" v-if="p === 0">
          <div class="large-6 columns end">
            <div :class="['pax-field', {'has-error':paxErrorFields.adult.indexOf(`email${p}`) > -1}]">
              <div class="pax-field-label">Email address<span>*</span></div>
              <input type="text" placeholder="Email"
                v-model="pax[`email${p}`]" @change="highlightCheck"
                :class="['no-outline', {active: highlight.active === `adult-email${p}`}]" />
            </div>
          </div>
        </div>

        <div class="row rv-addrss" v-if="p === 0">
          <div class="large-4 columns end">
            <div :class="['pax-field', {'has-error':paxErrorFields.adult.indexOf(`address${p}`) > -1}]">
              <div class="pax-field-label">Address<span>*</span></div>
              <input type="text" placeholder="Address"
                v-model="pax[`address${p}`]" @change="highlightCheck"
                :class="['no-outline', {active: highlight.active === `adult-address${p}`}]" />
            </div>
          </div>
          <div class="large-4 columns end">
            <div :class="['pax-field', {'has-error':paxErrorFields.adult.indexOf(`city${p}`) > -1}]">
              <div class="pax-field-label">City<span>*</span></div>
              <input type="text" placeholder="City"
                v-model="pax[`city${p}`]" @change="highlightCheck"
                :class="['no-outline', {active: highlight.active === `adult-city${p}`}]" />
            </div>
          </div>
          <div class="large-4 columns end">
            <div :class="['pax-field', {'has-error':paxErrorFields.adult.indexOf(`zip${p}`) > -1}]">
              <div class="pax-field-label">Zip code<span>*</span></div>
              <input type="text" placeholder="Zip Code"
                v-model="pax[`zip${p}`]" @change="highlightCheck"
                :class="['no-outline', {active: highlight.active === `adult-zip${p}`}]" />
            </div>
          </div>
        </div>

        <div class="row rv-addrss">
          <div class="large-5 columns end">
            <div class="pax-field-label">Country of issue<span>*</span></div>
            <select :class="['country-selector no-outline', {'has-error':paxErrorFields.adult.indexOf(`country${p}`) > -1, active: highlight.active === `adult-country${p}`}]" 
              v-model="pax[`country${p}`]" @change="gtagTrackPax('country', 'adult', p)">
              <option value="" disabled>Select Country</option>
              <option v-for="(country, i) in countryList" :key="i" :value="country.code.toUpperCase()">{{cleanCountryName(country.name)}}</option>
            </select>
          </div>
          <div class="large-5 columns end">
            <div class="pax-field">
              <div class="pax-field-label">Passport number (optional)</div>
              <input type="text" placeholder="Passport Number (Optional)" v-model="pax[`passport${p}`]"
                class="no-outline"/>
            </div>
          </div>
        </div>

        <div class="row" v-if="p === 0">
          <div class="large-6 columns end">
            <div class="pax-field-label">Mobile number<span>*</span></div>
            <div class="require-txt text-left" v-if="bookingAsGuest && !isMobileVerified">Phone verification is required.</div>
            <mobile-input :needVerification="bookingAsGuest && !isMobileVerified" :mobile="pax[`mobile${p}`]" @verified="paxMobileVerified"
              @updateMobile="pax[`countryCode${p}`] = $event.countryCode; pax[`mobile${p}`] = $event.mobile; highlightCheck()" :dialCode="pax[`countryCode${p}`]" :forPax="true" :uniqID="'mobile2'"
              :required="true" :hasError="paxErrorFields.adult.indexOf(`mobile${p}`) > -1"
              :class="['no-outline', {active: highlight.active === `adult-mobile${p}`}]"></mobile-input>
          </div>
        </div>
        
        <div class="row">
          <div class="large-6 columns end">
            <div :class="['pax-field', {'has-error':paxErrorFields.adult.indexOf(`bday${p}`) > -1 || paxErrorFields.adult.indexOf(`birthMonth${p}`) > -1, active:highlight.active === `adult-birthMonth${p}`}]">
              <div class="pax-field-label">Date of Birth<span>*</span></div>
              <!-- <datepicker v-on:input="changeDate($event, 'adult', p)" :value="`${pax[`birthMonth${p}`]} ${pax[`birthDay${p}`]}, ${pax[`birthYear${p}`]}`" -->
              <datepicker v-on:input="changeDate($event, 'adult', p)" :value="`${paxForm.adult[p][`birthMonth${p}`]} ${paxForm.adult[p][`birthDay${p}`]}, ${paxForm.adult[p][`birthYear${p}`]}`"
                :format="'MMM dd, yyyy'" input-class="d2d-bday no-outline" :minimumView="'year'" :initialView="'year'">
              </datepicker>
            </div>
          </div>
        </div>
        <div class="row" v-if="false">
          <div class="medium-12 columns" style="margin-bottom:2px">
            <div class="pax-field-label label-up">Date of Birth</div>
          </div>
        </div>
        <div class="row rv-addrss" v-if="false">
          <div class="medium-4 large-2 columns end pax-field">
            <div class="pax-field-label">Month<span>*</span></div>
            <select v-model="pax[`birthMonth${p}`]" @change="highlightCheck"
              :class="['pax-bday no-outline', {'has-error':paxErrorFields.adult.indexOf(`bday${p}`) > -1 || paxErrorFields.adult.indexOf(`birthMonth${p}`) > -1, active:highlight.active === `adult-birthMonth${p}`}]">
              <option value="" disabled selected>Birth Month</option>
              <option value="01">Jan</option>
              <option value="02">Feb</option>
              <option value="03">Mar</option>
              <option value="04">Apr</option>
              <option value="05">May</option>
              <option value="06">Jun</option>
              <option value="07">Jul</option>
              <option value="08">Aug</option>
              <option value="09">Sep</option>
              <option value="10">Oct</option>
              <option value="11">Nov</option>
              <option value="12">Dec</option>
            </select>
          </div>
          <div class="medium-4 large-2 columns end pax-field">
            <div class="pax-field-label">Day<span>*</span></div>
            <select v-model="pax[`birthDay${p}`]" @change="highlightCheck"
              :class="['pax-bday no-outline', {'has-error':paxErrorFields.adult.indexOf(`bday${p}`) > -1 || paxErrorFields.adult.indexOf(`birthDay${p}`) > -1, active:highlight.active === `adult-birthDay${p}`}]">
              <option value="" disabled selected>Birth Day</option>
              <option v-for="x in 31" :value="leadingZero(x)" :key="x">{{leadingZero(x)}}</option>
            </select>
          </div>
          <div class="medium-4 large-2 columns end pax-field">
            <div class="pax-field-label">Year<span>*</span></div>
            <select class="pax-bday" v-model="pax[`birthYear${p}`]" @change="highlightCheck"
              :class="['pax-bday no-outline', {'has-error':paxErrorFields.adult.indexOf(`bday${p}`) > -1 || paxErrorFields.adult.indexOf(`birthYear${p}`) > -1, active:highlight.active === `adult-birthYear${p}`}]">
              <option value="" disabled selected>Birth Year</option>
              <option :value="currentYear">{{currentYear}}</option>
              <option v-for="x in 99" :value="currentYear - x" :key="x">{{currentYear - x}}</option>
            </select>
          </div>
        </div>

      </div>

      <hr class="pax-split" v-if="paxForm.children.length" />

      <div :class="['pax-form', {'need-auth':showAuthBox && !bookingAsGuest}]" v-for="(pax, p) in paxForm.children" :key="p">
        <div class="blocker"></div>

        <div class="pax-id d-flex align-center">
          <b>Children {{ p + 1 }}</b>
          <label class="for-someone" v-if="p === 0 && !paxForm.adult.length && !bookingAsGuest">
            <input type="checkbox" v-model="forSomeoneElse" @change="toggleForSomeone" />
            <span>Book for someone else.</span>
          </label>
        </div>

        <div class="pax-basic-info align-start">
          <div>
            <div class="pax-field-label">Title<span>*</span></div>
            <select v-model="pax[`title${p}`]" @change="highlightCheck"
              :class="['pax-title no-outline', {'has-error':paxErrorFields.children.indexOf(`title${p}`) > -1, active: highlight.active === `children-title${p}`}]">
              <option value="">--</option>
              <option value="Mr">Mr.</option>
              <option value="Ms">Ms.</option>
              <option value="Mrs">Mrs.</option>
              <option value="Miss">Miss</option>
              <option value="Mstr">Mstr</option>
            </select>
          </div>
          <div :class="['pax-field', {'has-error':paxErrorFields.children.indexOf(`firstName${p}`) > -1}]">
            <div class="pax-field-label">First name<span>*</span></div>
            <input type="text" placeholder="First Name"
              v-model="pax[`firstName${p}`]" @change="gtagTrackPax('firstName', 'children', p)"
              :class="['no-outline', {active: highlight.active === `children-firstName${p}`}]" />
          </div>
          <div class="pax-field">
            <div class="pax-field-label">Middle name</div>
            <input type="text" placeholder="Middle Name (Optional)" class="no-outline"
              v-model="pax[`middleName${p}`]" @change="gtagTrackPax('middleName', 'children', p)"/>
          </div>
          <div :class="['pax-field', {'has-error':paxErrorFields.children.indexOf(`lastName${p}`) > -1}]">
            <div class="pax-field-label">Last name<span>*</span></div>
            <input type="text" placeholder="Last Name"
              v-model="pax[`lastName${p}`]" @change="gtagTrackPax('lastName', 'children', p)"
              :class="['no-outline', {active: highlight.active === `children-lastName${p}`}]"/>
          </div>
          <div>
            <div class="pax-field-label">Suffix</div>
            <select class="pax-title no-outline" v-model="pax[`suffix${p}`]">
              <option value="">--</option>
              <option value="Jr">Jr</option>
              <option value="SR">SR</option>
              <option value="II">II</option>
              <option value="III">III</option>
              <option value="IV">IV</option>
            </select>
          </div>
          <div>
            <div class="pax-field-label">Gender<span>*</span></div>
            <select :class="['pax-title no-outline', {'has-error':paxErrorFields.children.indexOf(`gender${p}`) > -1, active: highlight.active === `children-gender${p}`}]"
              v-model="pax[`gender${p}`]" @change="gtagTrackPax('gender', 'children', p)">
            <option value="">--</option>
            <option value="1">Male</option>
            <option value="2">Female</option>
          </select>
          </div>
        </div>

        <div class="row" v-if="p === 0 && !filters.travellers.adult">
          <div class="large-6 columns end">
            <div :class="['pax-field', {'has-error':paxErrorFields.children.indexOf(`email${p}`) > -1}]">
              <div class="pax-field-label">Email address<span>*</span></div>
              <input type="text" placeholder="Email" v-model="pax[`email${p}`]"
                :class="['no-outline', {active: highlight.active === `children-email${p}`}]"
                @change="highlightCheck" />
            </div>
          </div>
        </div>

        <div class="row rv-addrss" v-if="false">
          <div class="large-4 columns end">
            <div :class="['pax-field', {'has-error':paxErrorFields.children.indexOf(`address${p}`) > -1}]">
              <div class="pax-field-label">Address<span>*</span></div>
              <input type="text" placeholder="Address" v-model="pax[`address${p}`]"
                :class="['no-outline', {active: highlight.active === `children-address${p}`}]"
                @change="highlightCheck" />
            </div>
          </div>
          <div class="large-4 columns end">
            <div :class="['pax-field', {'has-error':paxErrorFields.children.indexOf(`city${p}`) > -1}]">
              <div class="pax-field-label">City<span>*</span></div>
              <input type="text" placeholder="City" v-model="pax[`city${p}`]"
                :class="['no-outline', {active: highlight.active === `children-city${p}`}]"
                @change="highlightCheck" />
            </div>
          </div>
          <div class="large-4 columns end">
            <div :class="['pax-field', {'has-error':paxErrorFields.children.indexOf(`zip${p}`) > -1}]">
              <div class="pax-field-label">Zip code<span>*</span></div>
              <input type="text" placeholder="Zip Code" v-model="pax[`zip${p}`]"
                :class="['no-outline', {active: highlight.active === `children-zip${p}`}]"
                @change="highlightCheck" />
            </div>
          </div>
        </div>

        <div class="row rv-addrss">
          <div class="large-5 columns end">
            <div class="pax-field-label">Country of issue<span>*</span></div>
            <select :class="['country-selector no-outline', {'has-error':paxErrorFields.children.indexOf(`country${p}`) > -1, 'active':highlight.active === `children-country${p}`}]" 
              v-model="pax[`country${p}`]" @change="gtagTrackPax('country', 'children', p)">
              <option value="" disabled>Select Country</option>
              <option v-for="(country, i) in countryList" :key="i" :value="country.code.toUpperCase()">{{cleanCountryName(country.name)}}</option>
            </select>
          </div>
          <div class="large-5 columns end">
            <div class="pax-field">
              <div class="pax-field-label">Passport number (optional)</div>
              <input type="text" placeholder="Passport Number (Optional)" v-model="pax[`passport${p}`]"
                class="no-outline"/>
            </div>
          </div>
        </div>

        <div class="row" v-if="p === 0 && !filters.travellers.adult">
          <div class="large-6 columns end">
            <div class="pax-field-label">Mobile number<span>*</span></div>
            <div class="require-txt text-left" v-if="bookingAsGuest">Phone verification is required.</div>
            <mobile-input :needVerification="bookingAsGuest" mobile="" :forPax="true" @verified="paxMobileVerified"
              @updateMobile="pax[`countryCode${p}`] = $event.countryCode;pax[`mobile${p}`] = $event.mobile; highlightCheck()" dialCode="" :uniqID="'mobile3'"
              :required="false" :hasError="paxErrorFields.children.indexOf(`mobile${p}`) > -1"
              :class="['no-outline', {active: highlight.active === `children-mobile${p}`}]"></mobile-input>
          </div>
        </div>

        <div class="row">
          <div class="large-6 columns end">
            <div :class="['pax-field', {'has-error':paxErrorFields.children.indexOf(`bday${p}`) > -1 || paxErrorFields.children.indexOf(`birthMonth${p}`) > -1, active:highlight.active === `children-birthMonth${p}`}]">
              <div class="pax-field-label">Date of Birth<span>*</span></div>
              <datepicker v-on:input="changeDate($event, 'children', p)" :value="`${paxForm.children[p][`birthMonth${p}`]} ${paxForm.children[p][`birthDay${p}`]}, ${paxForm.children[p][`birthYear${p}`]}`"
                :format="'MMM dd, yyyy'" input-class="d2d-bday no-outline" :minimumView="'year'" :initialView="'year'">
              </datepicker>
            </div>
          </div>
        </div>
        <div class="row" v-if="false">
          <div class="medium-12 columns" style="margin-bottom:2px">
            <div class="pax-field-label label-up">Date of Birth</div>
          </div>
        </div>
        <div class="row rv-addrss" v-if="false">
          <div class="medium-4 large-2 columns end pax-field">
            <div class="pax-field-label">Month<span>*</span></div>
            <select v-model="pax[`birthMonth${p}`]" @change="highlightCheck"
              :class="['pax-bday no-outline', {'has-error':paxErrorFields.children.indexOf(`bday${p}`) > -1 || paxErrorFields.children.indexOf(`birthMonth${p}`) > -1, active:highlight.active === `children-birthMonth${p}`}]">
              <option value="" disabled selected>Birth Month</option>
              <option value="01">Jan</option>
              <option value="02">Feb</option>
              <option value="03">Mar</option>
              <option value="04">Apr</option>
              <option value="05">May</option>
              <option value="06">Jun</option>
              <option value="07">Jul</option>
              <option value="08">Aug</option>
              <option value="09">Sep</option>
              <option value="10">Oct</option>
              <option value="11">Nov</option>
              <option value="12">Dec</option>
            </select>
          </div>
          <div class="medium-4 large-2 columns end pax-field">
            <div class="pax-field-label">Day<span>*</span></div>
            <select v-model="pax[`birthDay${p}`]" @change="highlightCheck"
              :class="['pax-bday no-outline', {'has-error':paxErrorFields.children.indexOf(`bday${p}`) > -1 || paxErrorFields.children.indexOf(`birthDay${p}`) > -1, active:highlight.active === `children-birthDay${p}`}]">
              <option value="" disabled selected>Birth Day</option>
              <option v-for="x in 31" :value="leadingZero(x)" :key="x">{{leadingZero(x)}}</option>
            </select>
          </div>
          <div class="medium-4 large-2 columns end pax-field">
            <div class="pax-field-label">Year<span>*</span></div>
            <select v-model="pax[`birthYear${p}`]" @change="highlightCheck"
              :class="['pax-bday no-outline', {'has-error':paxErrorFields.children.indexOf(`bday${p}`) > -1 || paxErrorFields.children.indexOf(`birthYear${p}`) > -1, active:highlight.active === `children-birthYear${p}`}]">
              <option value="" disabled selected>Birth Year</option>
              <option :value="currentYear">{{currentYear}}</option>
              <option v-for="x in 99" :value="currentYear - x" :key="x">{{currentYear - x}}</option>
            </select>
          </div>
        </div>
      </div>

      <hr class="pax-split" v-if="paxForm.infants.length" />

      <div :class="['pax-form', {'need-auth':showAuthBox && !bookingAsGuest}]" v-for="(pax, p) in paxForm.infants" :key="p">
        <div class="blocker"></div>
        <div class="pax-id d-flex align-center">
          <b>Infant {{ p + 1 }}</b>
          <label class="for-someone" v-if="p === 0 && !paxForm.adult.length && !paxForm.children.length && !bookingAsGuest">
            <input type="checkbox" v-model="forSomeoneElse" @change="toggleForSomeone" />
            <span>Book for someone else.</span>
          </label>
        </div>

        <div class="pax-basic-info align-start">
          <div>
            <div class="pax-field-label">Title<span>*</span></div>
            <select @change="highlightCheck" v-model="pax[`title${p}`]"
              :class="['pax-title no-outline', {'has-error':paxErrorFields.infants.indexOf(`title${p}`) > -1, active: highlight.active === `infant-title${p}`}]">
              <option value="">--</option>
              <option value="Mr">Mr.</option>
              <option value="Ms">Ms.</option>
              <option value="Mrs">Mrs.</option>
              <option value="Miss">Miss</option>
              <option value="Mstr">Mstr</option>
            </select>
          </div>
          <div :class="['pax-field', {'has-error':paxErrorFields.infants.indexOf(`firstName${p}`) > -1}]">
            <div class="pax-field-label">First name<span>*</span></div>
            <input type="text" placeholder="First Name"
              v-model="pax[`firstName${p}`]" @change="gtagTrackPax('firstName', 'infants', p)"
              :class="['no-outline', {active: highlight.active === `infants-firstName${p}`}]" />
          </div>
          <div class="pax-field">
            <div class="pax-field-label">Middle name</div>
            <input type="text" placeholder="Middle Name (Optional)"
              v-model="pax[`middleName${p}`]" @change="gtagTrackPax('middleName', 'infants', p)"
              :class="['no-outline', {active: highlight.active === `infants-middleName${p}`}]" />
          </div>
          <div :class="['pax-field', {'has-error':paxErrorFields.infants.indexOf(`lastName${p}`) > -1}]">
            <div class="pax-field-label">Last name<span>*</span></div>
            <input type="text" placeholder="Last Name"
              v-model="pax[`lastName${p}`]" @change="gtagTrackPax('lastName', 'infants', p)"
              :class="['no-outline', {active: highlight.active === `infants-lastName${p}`}]"/>
          </div>
          <div>
            <div class="pax-field-label">Suffix</div>
            <select class="pax-title no-outline" v-model="pax[`suffix${p}`]">
              <option value="">--</option>
              <option value="Jr">Jr</option>
              <option value="SR">SR</option>
              <option value="II">II</option>
              <option value="III">III</option>
              <option value="IV">IV</option>
            </select>
          </div>
          <div>
            <div class="pax-field-label">Gender<span>*</span></div>
            <select :class="['pax-title no-outline', {'has-error':paxErrorFields.infants.indexOf(`gender${p}`) > -1, active: highlight.active === `infants-gender${p}`}]"
              v-model="pax[`gender${p}`]" @change="gtagTrackPax('gender', 'infants', p)">
              <option value="">--</option>
              <option value="1">Male</option>
              <option value="2">Female</option>
            </select>
          </div>
        </div>

        <div class="row" v-if="p === 0 && !filters.travellers.adult && !filters.travellers.children">
          <div class="large-6 columns end">
            <div :class="['pax-field', {'has-error':paxErrorFields.infants.indexOf(`email${p}`) > -1}]">
              <div class="pax-field-label">Email address<span>*</span></div>
              <input type="text" placeholder="Email" v-model="pax[`email${p}`]"
                :class="['no-outline', {active: highlight.active === `infants-email${p}`}]"
                @change="highlightCheck"/>
            </div>
          </div>
        </div>

        <div class="row rv-addrss" v-if="false">
          <div class="large-4 columns end">
            <div :class="['pax-field', {'has-error':paxErrorFields.infants.indexOf(`address${p}`) > -1}]">
              <div class="pax-field-label">Address<span>*</span></div>
              <input type="text" placeholder="Address" v-model="pax[`address${p}`]"
                :class="['no-outline', {active: highlight.active === `infants-address${p}`}]"
                @change="highlightCheck"/>
            </div>
          </div>
          <div class="large-4 columns end">
            <div :class="['pax-field', {'has-error':paxErrorFields.infants.indexOf(`city${p}`) > -1}]">
              <div class="pax-field-label">City<span>*</span></div>
              <input type="text" placeholder="City" v-model="pax[`city${p}`]"
                :class="['no-outline', {active: highlight.active === `infants-city${p}`}]"
                @change="highlightCheck"/>
            </div>
          </div>
          <div class="large-4 columns end">
            <div :class="['pax-field', {'has-error':paxErrorFields.infants.indexOf(`zip${p}`) > -1}]">
              <div class="pax-field-label">Zip code<span>*</span></div>
              <input type="text" placeholder="Zip Code" v-model="pax[`zip${p}`]"
                :class="['no-outline', {active: highlight.active === `infants-zip${p}`}]"
                @change="highlightCheck"/>
            </div>
          </div>
        </div>

        <div class="row rv-addrss">
          <div class="large-5 columns end">
            <div class="pax-field-label">Country of issue<span>*</span></div>
            <select :class="['country-selector no-outline', {'has-error':paxErrorFields.infants.indexOf(`country${p}`) > -1, active: highlight.active === `infants-country${p}`}]" v-model="pax[`country${p}`]" @change="gtagTrackPax('country', 'infants', p)">
              <option value="" disabled>Select Country</option>
              <option v-for="(country, i) in countryList" :key="i" :value="country.code.toUpperCase()">{{cleanCountryName(country.name)}}</option>
            </select>
          </div>
          <div class="large-5 columns end">
            <div class="pax-field">
              <div class="pax-field-label">Passport number (optional)</div>
              <input type="text" placeholder="Passport Number (Optional)" v-model="pax[`passport${p}`]"
                class="no-outline"/>
            </div>
          </div>
        </div>

        <div class="row" v-if="p === 0 && !filters.travellers.adult && !filters.travellers.children">
          <div class="large-6 columns end">
            <div class="pax-field-label">Mobile number<span>*</span></div>
            <div class="require-txt text-left" v-if="bookingAsGuest">Phone verification is required.</div>
            <mobile-input :needVerification="bookingAsGuest" mobile="" :forPax="true" @verified="paxMobileVerified"
              @updateMobile="pax[`countryCode${p}`] = $event.countryCode;pax[`mobile${p}`] = $event.mobile;highlightCheck()" dialCode="" :uniqID="'mobile4'"
              :required="false" :hasError="paxErrorFields.infants.indexOf(`mobile${p}`) > -1"
              :class="['no-outline', {active: highlight.active === `infants-mobile${p}`}]"></mobile-input>
          </div>
        </div>

        <div class="row">
          <div class="large-6 columns end">
            <div :class="['pax-field ', {'has-error':paxErrorFields.infants.indexOf(`bday${p}`) > -1 || paxErrorFields.infants.indexOf(`birthMonth${p}`) > -1, active:highlight.active === `infants-birthMonth${p}`}]">
              <div class="pax-field-label">Date of Birth<span>*</span></div>
              <datepicker v-on:input="changeDate($event, 'infants', p)" :value="`${paxForm.infants[p][`birthMonth${p}`]} ${paxForm.infants[p][`birthDay${p}`]}, ${paxForm.infants[p][`birthYear${p}`]}`"
                :format="'MMM dd, yyyy'" input-class="d2d-bday no-outline" :minimumView="'year'" :initialView="'year'">
              </datepicker>
            </div>
          </div>
        </div>
        <div class="row" v-if="false">
          <div class="medium-12 columns" style="margin-bottom:2px">
            <div class="pax-field-label label-up">Date of Birth</div>
          </div>
        </div>
        <div class="row rv-addrss" v-if="false">
          <div class="medium-4 large-2 columns end pax-field">
            <div class="pax-field-label">Month<span>*</span></div>
            <select v-model="pax[`birthMonth${p}`]" @change="highlightCheck"
              :class="['pax-bday no-outline', {'has-error':paxErrorFields.infants.indexOf(`bday${p}`) > -1 || paxErrorFields.infants.indexOf(`birthMonth${p}`) > -1, active: highlight.active === `infants-birthMonth${p}`}]">
              <option value="" disabled selected>Birth Month</option>
              <option value="01">Jan</option>
              <option value="02">Feb</option>
              <option value="03">Mar</option>
              <option value="04">Apr</option>
              <option value="05">May</option>
              <option value="06">Jun</option>
              <option value="07">Jul</option>
              <option value="08">Aug</option>
              <option value="09">Sep</option>
              <option value="10">Oct</option>
              <option value="11">Nov</option>
              <option value="12">Dec</option>
            </select>
          </div>
          <div class="medium-4 large-2 columns end pax-field">
            <div class="pax-field-label">Day<span>*</span></div>
            <select v-model="pax[`birthDay${p}`]" @change="highlightCheck"
              :class="['pax-bday no-outline', {'has-error':paxErrorFields.infants.indexOf(`bday${p}`) > -1 || paxErrorFields.infants.indexOf(`birthDay${p}`) > -1, active: highlight.active === `infants-birthDay${p}`}]">
              <option value="" disabled selected>Birth Day</option>
              <option v-for="x in 31" :value="leadingZero(x)" :key="x">{{leadingZero(x)}}</option>
            </select>
          </div>
          <div class="medium-4 large-2 columns end pax-field">
            <div class="pax-field-label">Year<span>*</span></div>
            <select v-model="pax[`birthYear${p}`]" @change="highlightCheck"
              :class="['pax-bday no-outline', {'has-error':paxErrorFields.infants.indexOf(`bday${p}`) > -1 || paxErrorFields.infants.indexOf(`birthYear${p}`) > -1, active: highlight.active === `infants-birthYear${p}`}]">
              <option value="" disabled selected>Birth Year</option>
              <option :value="currentYear">{{currentYear}}</option>
              <option v-for="x in 99" :value="currentYear - x" :key="x">{{currentYear - x}}</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="submit-pax-box" v-if="renderPax || bookingAsGuest"> <!-- v-if="!showAuthBox && !cardsLoading" -->
      <div class="error-msg" v-if="error.pax.length">
        <div v-for="(err, e) in error.pax" :key="e">- {{err}}</div>
      </div>

      <!-- <div class="op-btn btn-md btn-block btn-success" @click="submitPax" v-if="false">SUBMIT</div> -->
      <!-- <div class="op-btn btn-md btn-block btn-success" @click="setGuestToken">SUBMIT</div> -->
    </div>

    <div class="auth-wrap d-flex justify-center" v-if="(showAuthBox && !bookingAsGuest) && !cardsLoading">
      <div class="auth-box">
        <div v-if="showForgot">
          <div class="page-title">Forgot Password</div>
          <div class="pax-field">
            <input type="text" placeholder="Email" v-model="emailForgot" @keyup.enter="sendForgot" autocomplete="one-time-code" />
          </div>

          <div class="error-msg" v-if="errorForgot">{{errorForgot}}</div>

          <div class="op-btn btn-md btn-block btn-success login-btn" @click="sendForgot">SEND FORGOT PASSWORD</div>

          <a @click="cancelForgot" href="javascript:;">Cancel</a>
        </div>

        <div v-else-if="showSignup">
          <div class="page-title">Sign Up</div>
          <div class="d-flex multi-fields">
            <div :class="['pax-field', {'has-error':errorFields.signup.indexOf('gender') > -1}]" @change="gtagTrack('gender')">
              <select v-model="gender" :class="['pax-bday', {'has-error':errorFields.signup.indexOf('gender') > -1}]">
                <option value="">--</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </div>
            <div :class="['pax-field', {'has-error':errorFields.signup.indexOf('title') > -1}]" @change="gtagTrack('title')">
              <select v-model="title" :class="['pax-bday', {'has-error':errorFields.signup.indexOf('title') > -1}]">
                <option value="">--</option>
                <option value="Mr">Mr.</option>
                <option value="Ms">Ms.</option>
                <option value="Mrs">Mrs.</option>
                <option value="Miss">Miss</option>
                <option value="Mstr">Mstr</option>
              </select>
            </div>
          </div>

          <div class="d-flex multi-fields">
            <div :class="['pax-field', {'has-error':errorFields.signup.indexOf('firstName') > -1}]" @change="gtagTrack('firstName')">
              <input type="text" placeholder="First Name" v-model="firstName" />
            </div>
            <div :class="['pax-field', {'has-error':errorFields.signup.indexOf('lastName') > -1}]" @change="gtagTrack('lastName')">
              <input type="text" placeholder="Last Name" v-model="lastName" />
            </div>
          </div>

          <div class="pax-field d-flex justify-space-between" style="gap: 10px">
            <select v-model="birthMonth" :class="['pax-bday', {'has-error':errorFields.signup.indexOf('birthMonth') > -1}]">
              <option value="" disabled selected>Birth Month</option>
              <option value="01">Jan</option>
              <option value="02">Feb</option>
              <option value="03">Mar</option>
              <option value="04">Apr</option>
              <option value="05">May</option>
              <option value="06">Jun</option>
              <option value="07">Jul</option>
              <option value="08">Aug</option>
              <option value="09">Sep</option>
              <option value="10">Oct</option>
              <option value="11">Nov</option>
              <option value="12">Dec</option>
            </select>
            <select v-model="birthDay" :class="['pax-bday', {'has-error':errorFields.signup.indexOf('birthDay') > -1}]">
              <option value="" disabled selected>Birth Day</option>
              <option v-for="x in 31" :value="leadingZero(x)" :key="x">{{leadingZero(x)}}</option>
            </select>
            <select v-model="birthYear" :class="['pax-bday', {'has-error':errorFields.signup.indexOf('birthYear') > -1}]">
              <option value="" disabled selected>Birth Year</option>
              <option :value="currentYear">{{currentYear}}</option>
              <option v-for="x in 99" :value="currentYear - x" :key="x">{{currentYear - x}}</option>
            </select>
          </div>

          <div class="d-flex multi-fields">
            <div :class="['pax-field', {'has-error':errorFields.signup.indexOf('address') > -1}]" @change="gtagTrack('address')">
              <input type="text" placeholder="Address" v-model="address" />
            </div>
            <div :class="['pax-field', {'has-error':errorFields.signup.indexOf('city') > -1}]" @change="gtagTrack('city')">
              <input type="text" placeholder="City" v-model="city" />
            </div>
          </div>

          <div class="d-flex multi-fields">
            <div :class="['pax-field', {'has-error':errorFields.signup.indexOf('zip') > -1}]" @change="gtagTrack('zip')">
              <input type="text" placeholder="Zip" v-model="zip" />
            </div>
            <div class="pax-field">
              <select :class="['country-selector', {'has-error':errorFields.signup.indexOf('country') > -1}]" v-model="country" placeholder="Country">
                <option value="" disabled>Select Country</option>
                <option v-for="(country, i) in countryList" :key="i" :value="country.code.toUpperCase()">{{cleanCountryName(country.name)}}</option>
              </select>
            </div>
          </div>

          <div class="pax-field">
            <input type="text" placeholder="Passport Number (Optional)" v-model="passportNum" />
          </div>

          <div class="require-txt text-left">Phone verification is required.</div>
          <mobile-input :needVerification="true" :mobile="mobile" @verified="mobileVerified" 
            @updateMobile="updateMobileInfo" ref="userMobile" :dialCode="countryCode" :uniqID="'mobile5'"
            :required="true" :hasError="errorFields.signup.indexOf('mobile') > -1"></mobile-input>

          <div :class="['pax-field', {'has-error':errorFields.signup.indexOf('email') > -1}]">
            <input type="email" placeholder="Email" v-model="email" autocomplete="one-time-code" @change="gtagTrack('email')"/>
          </div>
          <div class="d-flex multi-fields">
            <div :class="['pax-field', {'has-error':errorFields.signup.indexOf('password') > -1}]">
              <input type="password" placeholder="Password" v-model="password"
                autocomplete="one-time-code" />
            </div>
            <div :class="['pax-field', {'has-error':errorFields.signup.indexOf('rpassword') > -1}]">
              <input type="password" placeholder="Repeat Password" v-model="rpassword"
                autocomplete="one-time-code" />
            </div>
          </div>

          <div class="error-msg" v-if="error.signup.length">
            <div v-if="error.signup.indexOf('E_EMAIL_EXISTS') > -1">
              {{ $t('customerForm.emailExist') }}
              <a href="javascript:;" v-on:click="initShowLogin">{{ $t('customerForm.clickHere') }}</a> 
              {{ $t('customerForm.toSignIn') }}
              <br/>
              {{ $t('customerForm.otherwisePlease') }}
            </div>
            <div v-else v-for="(err, e) in error.signup" :key="e">- {{err}}</div>
          </div>

          <div class="op-btn btn-md btn-block btn-success signup-btn" @click="signup">SIGN UP</div>

          <div class="no-account">
            Already have an account?
            <a @click="initShowLogin">Login</a>
          </div>

          <a class="as-guest" @click="bookAsGuest">
            Continue as guest.
          </a>
        </div>

        <div v-else>
          <email-mobile-form 
            @loginUser="loginUser" @nonUser="nonUser"
            @getUserInfo="getUserInfo" @hideVeriForm="hideVeriForm"
          />
          <!-- <div class="page-title">Login</div>
          <div :class="['pax-field', {'has-error':errorFields.login.indexOf('email') > -1}]">
            <input type="text" placeholder="Email" v-model="email" @keyup.enter="login"
              autocomplete="one-time-code" />
          </div>
          <div :class="['pax-field', {'has-error':errorFields.login.indexOf('password') > -1}]">
            <input type="password" placeholder="Password" v-model="password"
              autocomplete="one-time-code" @keyup.enter="login" />
          </div>
          <div class="forgot-box"><span @click="initForgot">Forgot password?</span></div>

          <div class="error-msg" v-if="error.login.length">
            <div v-for="(err, e) in error.login" :key="e">- {{err}}</div>
          </div>

          <div class="op-btn btn-md btn-block btn-success login-btn" @click="login">LOGIN</div>

          <div class="no-account">
            Don't have an account?
            <a @click="initShowSignup">Sign Up</a>
          </div>

          <a class="as-guest" @click="bookAsGuest">
            Continue as guest.
          </a> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import mobileInput from './MobileInput'
import Datepicker from 'vuejs-datepicker'
import WidgetSession from '@/modules/session'
import CreditCard from '@/modules/api/credit-card'
import Credits from '@/modules/api/_credits'
import EmailMobileForm from "@/components/Global/EmailMobileForm.vue"

// const cookie = require('vue-cookie')
const countries = require('@/data/countries')

export default {
  name: 'pax-form',
  components: { mobileInput, Datepicker, EmailMobileForm },
  data () {
    return {
      paxForm: {
        adult: [],
        children: [],
        infants: []
      },
      paxErrorFields: {
        adult: [],
        children: [],
        infants: []
      },
      showAuthBox: false,
      email: '',
      password: '',
      showSignup: false,
      gender: '',
      title: '',
      firstName: '',
      lastName: '',
      birthDay: '',
      birthMonth: '',
      birthYear: '',
      address: '',
      city: '',
      zip: '',
      country: 'US',
      passportNum: '',
      mobile: '',
      countryCode: 1,
      isVerified: false,
      isMobileVerified: false,
      rpassword: '',
      error: {
        signup: [],
        login: [],
        pax: []
      },
      errorFields: {
        signup: [],
        login: []
      },
      session: '',
      countryList: Object.values(countries),
      cardsLoading: false,
      renderPax: true,
      currentYear: parseInt(moment().format('YYYY')),
      showForgot: false,
      emailForgot: '',
      errorForgot: '',
      rerenderMobile: true,
      highlight: {
        active: '',
        adultDone: false,
        childrenDone: false,
        infantsDone: false
      },
      paxFormMobileVerified: false
    }
  },
  computed: {
    booking () { return this.$store.state.booking },
    locations () { return this.booking.locations },
    filters () { return this.booking.filters },
    user () { return this.$store.state.user },
    _token () { return this.user.token },
    forSomeoneElse: {
      get () { return this.filters.travellers.forSomeoneElse },
      set (x) { this.$store.commit('booking/setTravellersData', {forSomeoneElse: x}) }
    },
    other () { return this.$store.state.other },
    _reviewAction () { return this.other.reviewAction },
    bookingAsGuest () { return this.booking.bookAsGuest },
    logoutStore () { return this.$store.state.global.logout }
  },
  methods: {
    logout () {
      this.$store.commit('global/setLogoutData', {show: true})
      // this.session.destroy()
      // this.$store.commit('user/reset')
      // cookie.delete('userToken')
      // if (this.$refs.userMobile && this.$refs.userMobile.changePhoneNumber()) {
      //   this.$refs.userMobile.changePhoneNumber()
      // }
      // this.$store.commit('cards/setCardData', {
      //   lastUserID: '',
      //   list: []
      // })
      // this.$store.commit('setCredits', 0)
      // this.$store.commit('booking/setOthersData', {bookAsGuest: true})
    },
    showSignupOption () {
      this.showAuthBox = false
      this.$store.commit('global/setAuthData', {signupSelect: true})
      this.$store.commit('booking/setOthersData', {bookAsGuest: false})
    },
    initShowSignup () {
      this.email = ''
      this.password = ''
      this.error.login = ''
      this.showSignup = true
      this.$store.commit('booking/setOthersData', {bookAsGuest: false})

      let self = this
      self.$nextTick(() => {
        self.$forceUpdate()
        let firstVisit = localStorage.getItem('firstVisitData')
        if (firstVisit) {
          firstVisit = JSON.parse(firstVisit)
          if (firstVisit.mobile) self.mobile = firstVisit.mobile
          if (firstVisit.countryCode) self.countryCode = firstVisit.countryCode
          if (firstVisit.mobile && firstVisit.countryCode) self.isVerified = true
        }
        if (self.$refs.userMobile && self.$refs.userMobile.recheckVerification()) {
          self.$refs.userMobile.recheckVerification()
        }
      })
      if (window.gtag) { // eslint-disable-line
        gtag('event', 'Pax Form - Signup') // eslint-disable-line
      }
    },
    mobileVerified (val) {
      this.isVerified = val
    },
    updateMobileInfo (val) {
      this.mobile = val.mobile
      this.countryCode = val.countryCode
    },
    login () {
      let self = this
      let hasError = false
      let fields = ['email', 'password']
      self.error.login = []
      self.errorFields.login = []
      fields.forEach(f => {
        if (!self[f]) {
          hasError = true
          self.errorFields.login.push(f)
        }
      })
      if (self.errorFields.login.length) {
        self.error.login.push('Please fill up the missing fields.')
      }
      if (hasError) return

      let newUserToken = this.session.generateUserToken(false)
      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.post(self, '/auth/login', {
        email: self.email,
        password: self.password,
        device: newUserToken,
        deviceType: 'web',
        d2d: 1
      }, res => {
        self.$store.commit('user/setIsCorporate', false)
        if (res.error) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.error.login.push(self.$t(res.error.message))
          return
        }
        self.loginSuccess(res, newUserToken)
      })
    },
    loginSuccess (res, newUserToken) {
      let self = this
      self.renderPax = false
      if (res.paxinfo && res.paxinfo.gender === "Male") self.paxForm.adult[0].gender0 = 1
      if (res.paxinfo && res.paxinfo.gender === "Female") self.paxForm.adult[0].gender0 = 2
      self.paxForm.adult[0].title0 = res.paxinfo && res.paxinfo.title || ''
      self.paxForm.adult[0].firstName0 = res.firstName
      self.paxForm.adult[0].lastName0 = res.lastName
      self.paxForm.adult[0].email0 = res.email
      self.paxForm.adult[0].mobile0 = res.phone
      self.paxForm.adult[0].countryCode0 = res.countryCode
      if (res.dateOfBirth) {
        let dob = moment(res.dateOfBirth, 'YYYY-MM-DD')
        self.paxForm.adult[0].birthDay0 = dob.format('DD')
        self.paxForm.adult[0].birthMonth0 = dob.format('MM')
        self.paxForm.adult[0].birthYear0 = dob.format('YYYY')
      }
      if (res.userCountry) self.paxForm.adult[0].country0 = res.userCountry
      if (res.passportNum) self.paxForm.adult[0].passport0 = res.passportNum
      setTimeout(() => {
        self.renderPax = true
      }, 100)

      self.cardsLoading = true
      self.session.useToken(newUserToken) // Only save the token if successful
      self.$store.commit('user/setToken', newUserToken)
      res.bday = res.dateOfBirth
      res.country = res.userCountry
      res.passportNum = res.passportNum
      if (res.paxinfo) {
        res.title = res.paxinfo.title
        res.gender = res.paxinfo.gender
        let address = res.paxinfo.address || ''
        let city = res.paxinfo.city || ''
        let zip = res.paxinfo.zip || ''
        self.$store.commit('user/setUserData', {
          address: address,
          city: city,
          zip: zip
        })
        if (address) self.filters.travellers.info.adult[0].address0 = address
        if (city) self.filters.travellers.info.adult[0].city0 = city
        if (zip) self.filters.travellers.info.adult[0].zip0 = zip
      }
      self.$store.commit('user/setUserInfo', res)
      self.getCredits()
    },
    // getAddress (token) {
    //   let self = this
    //   self.$sdk.get(self, '/me/locations', {token: token}, res => {
    //     self.getCards()
    //     if (res.error) return
    //     let home = res.home
    //     let address = home && home.addressLine1 ? home.addressLine1 : ''
    //     let city = home && home.city ? home.city : ''
    //     let zip = home && home.zipCode ? home.zipCode : ''
    //     self.$store.commit('user/setUserData', {
    //       address: address,
    //       city: city,
    //       zip: zip
    //     })
    //     if (address) self.filters.travellers.info.adult[0].address0 = address
    //     if (city) self.filters.travellers.info.adult[0].city0 = city
    //     if (zip) self.filters.travellers.info.adult[0].zip0 = zip
    //   }, '1.1')
    // },
    getCredits () {
      let self = this
      Credits.get(self, {token: self._token}, () => {
        self.getCards()
      })
    },
    getCards () {
      let self = this
      CreditCard.getCards(self, self.user.token, r => {
        self.cardsLoading = false
        self.$emit('getCardsDone')
        self.$store.commit('global/setLoaderData', {show: false})
      })
    },
    signup () {
      let self = this
      let hasError = false
      let fields = [
        'gender', 'title',
        'firstName', 'lastName',
        'birthMonth', 'birthDay', 'birthYear',
        'address', 'city', 'zip',
        'email', 'mobile',
        'password', 'rpassword'
      ]
      self.error.signup = []
      self.errorFields.signup = []
      fields.forEach(f => {
        if (!self[f]) {
          hasError = true
          self.errorFields.signup.push(f)
        }
      })
      if (self.errorFields.signup.length) {
        self.error.signup.push('Please fill up the missing fields.')
      }
      if (self.mobile && !self.isVerified) {
        hasError = true
        self.error.signup.push('Phone verification is required.')
      }
      let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (self.email && !pattern.test(self.email)) {
        hasError = true
        self.error.signup.push(self.$t('common.invalidEmail'))
        self.errorFields.signup.push('email')
      }
      let bday = ''
      if (self.birthDay && self.birthMonth && self.birthYear) {
        bday = moment(`${self.birthYear}-${self.birthMonth}-${self.birthDay}`, 'YYYY-MM-DD')
        if (!bday.isValid()) {
          bday = ''
          hasError = true
          self.error.signup.push('Invalid Birth Date')
          self.errorFields.signup.push('birthMonth', 'birthDay', 'birthYear')
        }
      }
      if (self.password && self.password.length < 8) {
        hasError = true
        self.error.signup.push('Password must be at least 8 characters.')
      }
      if (self.rpassword && self.rpassword.length < 8) {
        hasError = true
        self.error.signup.push('Repeat password must be at least 8 characters.')
      }
      if (self.password && self.rpassword && self.password !== self.rpassword) {
        hasError = true
        self.error.signup.push(self.$t('customerForm.passwordNotMatch'))
      }
      if (hasError) return

      let newUserToken = this.session.generateUserToken(false)
      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.post(self, '/auth/signup', {
        email: self.email,
        password: self.password,
        device: newUserToken,
        paxinfo: {
          title: self.title,
          gender: self.gender
        },
        firstName: self.firstName,
        lastName: self.lastName,
        phone: self.countryCode + self.mobile,
        dateOfBirth: bday.format('YYYY-MM-DD'),
        userCountry: self.country.toUpperCase(),
        passportNum: self.passportNum,
        wheelchair: false,
        serviceDog: false,
        brandID: self.$store.state.brandId,
        d2d: true
      }, res => {
        if (res.error) {
          // TODO: alert res.message
          // this.app.$emit('signupFailure', res)
          self.signupFailure(res)
          self.$store.commit('global/setLoaderData', {show: false})
          return
        }
        res.token = newUserToken
        self.session.useToken(newUserToken) // Only save the token if successful
        // self.app.$emit('signupSuccess', res.data)
        self.saveAddress(res)
        res.address = self.address
        res.city = self.city
        res.zip = self.zip
        self.signupSuccess(res)
      }, '1.1')
    },
    saveAddress (data, forGuest = false) {
      let self = this
      let address = forGuest ? data.address : self.address
      let city = forGuest ? data.city : self.city
      let zip = forGuest ? data.zip : self.zip
      self.$sdk.post(self, '/me/locations', {
        token: data.token,
        address1: address,
        address2: '',
        zip: zip,
        state: '',
        city: city,
        lat: 0,
        lng: 0,
        type: 'home'
      }, res => {
        if (res.error) {
          // self.loading = false
          // self.$store.commit('global/setLoaderData', {show: false})
          // self.$store.commit('global/setAlertData', {
          //   show: true,
          //   message: res.error.message
          // })
          return
        }
      })
    },
    signupSuccess (data) {
      let self = this
      self.$store.commit('global/setLoaderData', {show: false})
      if (data.mobile) data.phone = data.mobile
      data.bday = data.dateOfBirth
      data.country = data.userCountry.toUpperCase()
      data.passportNum = data.passportNum
      if (data.paxinfo) {
        data.title = data.paxinfo.title
        data.gender = data.paxinfo.gender
      }
      self.$store.commit('user/setUserInfo', data)
      self.$store.commit('user/setToken', data.token)

      if (self.filters.travellers.adult) {
        if (self.user.gender === "Male") self.filters.travellers.info.adult[0].gender0 = 1
        if (self.user.gender === "Female") self.filters.travellers.info.adult[0].gender0 = 2
        self.filters.travellers.info.adult[0].title0 = self.user.title
        self.filters.travellers.info.adult[0].firstName0 = self.user.firstName
        self.filters.travellers.info.adult[0].lastName0 = self.user.lastName
        self.filters.travellers.info.adult[0].email0 = self.user.email
        self.filters.travellers.info.adult[0].mobile0 = self.mobile
        self.filters.travellers.info.adult[0].countryCode0 = self.countryCode
        if (data.dateOfBirth) {
          let dob = moment(data.dateOfBirth, 'YYYY-MM-DD')
          self.filters.travellers.info.adult[0].birthDay0 = dob.format('DD')
          self.filters.travellers.info.adult[0].birthMonth0 = dob.format('MM')
          self.filters.travellers.info.adult[0].birthYear0 = dob.format('YYYY')
        }
        if (data.address) self.filters.travellers.info.adult[0].address0 = data.address
        if (data.city) self.filters.travellers.info.adult[0].city0 = data.city
        if (data.zip) self.filters.travellers.info.adult[0].zip0 = data.zip
        if (data.userCountry) self.filters.travellers.info.adult[0].country0 = data.userCountry
        if (data.passportNum) self.filters.travellers.info.adult[0].passport0 = data.passportNum
      }

      self.signupLoading = false
      self.signupFail = false
    },
    signupFailure (data) {
      this.signupLoading = false
      this.signupFail = true
      this.error.signup.push(data.error.message.replace('backend.', ''))
      if (data.message) this.error.signup = [data.message.replace('backend.', '')]
    },
    initShowLogin () {
      this.email = ''
      this.password = ''
      this.firstName = ''
      this.lastName = ''
      this.mobile = ''
      this.countryCode = ''
      this.rpassword = ''
      this.error.signup = []
      this.showSignup = false

      if (window.gtag) { // eslint-disable-line
        gtag('event', 'Pax Form - Login') // eslint-disable-line
      }
    },
    submitPax () {
      let self = this
      let adults = []
      let children = []
      let infants = []
      let hasError = false
      self.error.pax = []
      self.paxErrorFields = {
        adult: [],
        children: [],
        infants: []
      }

      let types = []
      let travellers = self.filters.travellers
      if (travellers.adult) types.push('adult')
      if (travellers.children) types.push('children')
      if (travellers.infants) types.push('infants')

      types.forEach(type => {
        self.paxForm[type].forEach((p, i) => {
          let tmp = Object.assign({}, p)
          let today = moment()
          let bday = ''
          let fields = [
            'title', 'firstName', 'lastName',
            'gender', 'birthMonth', 'birthDay',
            'birthYear',
            // 'address', 'city', 'zip',
            'country'
          ]
          if (i === 0 && type === 'adult' && travellers.adult) fields.push('address', 'city', 'zip')
          if (i === 0 &&
            (
              (type === 'adult' && travellers.adult) ||
              (type === 'children' && !travellers.adult && travellers.children) ||
              (type === 'infants' && !travellers.adult && !travellers.children && travellers.infants)
            )
          ) {
            fields.push('mobile', 'email')
          }
          fields.forEach(field => {
            if (!p[`${field}${i}`]) {
              hasError = true
              self.paxErrorFields[type].push(`${field}${i}`)
            }
            if (field === 'mobile' && p[`${field}${i}`] && self.bookingAsGuest && !self.paxFormMobileVerified) {
              hasError = true
              self.paxErrorFields[type].push(`${field}${i}`)
            }
          })
          if (hasError) {
            if (self.error.pax.indexOf('Please fill up the missing fields.') === -1) self.error.pax.push('Please fill up the missing fields.')
          }
          let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if (p[`email${i}`] && !pattern.test(p[`email${i}`])) {
            hasError = true
            self.error.pax.push(self.$t('common.invalidEmail'))
            self.paxErrorFields[type].push(`email${i}`)
          }

          if (p[`birthDay${i}`] && p[`birthMonth${i}`] && p[`birthYear${i}`]) {
            bday = moment(`${p[`birthYear${i}`]}-${p[`birthMonth${i}`]}-${p[`birthDay${i}`]}`, 'YYYY-MM-DD')
            if (!bday.isValid()) {
              bday = ''
              hasError = true
              self.error.pax.push('Invalid Birth Date')
              self.paxErrorFields[type].push(`bday${i}`)
            }
          }
          if (type === 'adult' && bday && today.diff(bday, 'years') < 13) {
            hasError = true
            self.error.pax.push('Adult must be 13 years old or above.')
            self.paxErrorFields[type].push(`bday${i}`)
          }
          if (
            type === 'children' && bday &&
            (today.diff(bday, 'years') > 12 || today.diff(bday, 'years') < 2)
          ) {
            hasError = true
            self.error.pax.push('Childrens age must be between 2-12.')
            self.paxErrorFields[type].push(`bday${i}`)
          }
          if (type === 'infants' && bday && today.diff(bday, 'years') >= 2) {
            hasError = true
            self.error.pax.push('Infants must be less than 2 years old.')
            self.paxErrorFields[type].push(`bday${i}`)
          }
          tmp[`bday${i}`] = bday ? bday.format('YYYY-MM-DD') : ''

          if (travellers.adult) {
            tmp[`mobile${i}`] = travellers.info.adult[0].mobile0
            tmp[`email${i}`] = travellers.info.adult[0].email0
          }
          if (!travellers.adult && travellers.children) {
            tmp[`mobile${i}`] = travellers.info.children[0].mobile0
            tmp[`email${i}`] = travellers.info.children[0].email0
          }
          if (!travellers.adult && !travellers.children && travellers.infants) {
            tmp[`mobile${i}`] = travellers.info.infants[0].mobile0
            tmp[`email${i}`] = travellers.info.infants[0].email0
          }

          if (type === 'adult') adults.push(tmp)
          if (type === 'children') children.push(tmp)
          if (type === 'infants') infants.push(tmp)
        })
      })

      if (hasError) {
        this.$emit('done', false)
        return
      }

      self.$store.commit('booking/addTravellerInfo', {
        adult: adults,
        children: children,
        infants: infants
      })
      if (self.bookingAsGuest) {
        self.setGuestToken()
        return
      }
      // self.$router.push('payment')
      this.$emit('done', true)
    },
    cleanCountryName (val) {
      let val2 = val.slice(0, val.indexOf(" ("))
      return val.indexOf(" (") === -1 ? val : val2
    },
    initForgot () {
      this.error.login = ''
      this.showForgot = true
    },
    sendForgot () {
      let self = this
      let hasError = false
      self.errorForgot = ''
      if (!self.emailForgot) {
        hasError = true
        self.errorForgot = 'Please input your email.'
      }
      let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (self.emailForgot && !pattern.test(self.emailForgot)) {
        hasError = true
        self.errorForgot = self.$t('common.invalidEmail')
      }
      if (hasError) return

      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.get('self', '/me/forgotpassword', {
        email: self.emailForgot,
        brand: 'dd',
        d2d: 1
      }, res => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (res.success) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'Forgot password email sent.'
          })
          self.showForgot = false
          self.emailForgot = ''
          return
        }
        self.$store.commit('global/setAlertData', {
          show: true,
          message: res.message
        })
      }, '')
    },
    cancelForgot () {
      this.showForgot = false
    },
    toggleForSomeone () {
      let travellers = this.filters.travellers
      if (!this.forSomeoneElse) {
        travellers.info.adult[0].firstName0 = this.user.firstName
        travellers.info.adult[0].lastName0 = this.user.lastName
        travellers.info.adult[0].mobile0 = this.user.phone.number
        travellers.info.adult[0].countryCode0 = this.user.phone.code
        travellers.info.adult[0].email0 = this.user.email
        if (this.user.bday) {
          let dob = moment(this.user.bday, 'YYYY-MM-DD')
          travellers.info.adult[0].birthDay0 = dob.format('DD')
          travellers.info.adult[0].birthMonth0 = dob.format('MM')
          travellers.info.adult[0].birthYear0 = dob.format('YYYY')
        }
        if (this.user.address) travellers.info.adult[0].address0 = this.user.address
        if (this.user.city) travellers.info.adult[0].city0 = this.user.city
        if (this.user.zip) travellers.info.adult[0].zip0 = this.user.zip
        if (this.user.country) travellers.info.adult[0].country0 = this.user.country
        if (this.user.passportNum) travellers.info.adult[0].passport0 = this.user.passportNum
        let self = this
        self.rerenderMobile = false
        setTimeout(function () {
          self.rerenderMobile = true
        }, 100)
      } else {
        travellers.info.adult[0].title0 = ''
        travellers.info.adult[0].gender0 = ''
        travellers.info.adult[0].firstName0 = ''
        travellers.info.adult[0].lastName0 = ''
        travellers.info.adult[0].mobile0 = ''
        travellers.info.adult[0].email0 = ''

        travellers.info.adult[0].birthDay0 = ''
        travellers.info.adult[0].birthMonth0 = ''
        travellers.info.adult[0].birthYear0 = ''
        travellers.info.adult[0].address0 = ''
        travellers.info.adult[0].city0 = ''
        travellers.info.adult[0].zip0 = ''
        travellers.info.adult[0].country0 = ''
        if (this.other.default.enabledLocation) travellers.info.adult[0].country0 = this.other.default.country
        travellers.info.adult[0].passport0 = ''
      }
    },
    leadingZero (x) {
      x = x + ''
      return x.length === 1 ? '0' + x : x
    },
    gtagTrack (field) {
      // if (window.gtag) { // eslint-disable-line
      //   gtag( // eslint-disable-line
      //     'event',
      //     `Signup_${field}`,
      //     {value: this[field]}
      //   )
      // }
    },
    gtagTrackPax (field, type, n) {
      // if (window.gtag && this.paxForm[type][n]) { // eslint-disable-line
      //   gtag( // eslint-disable-line
      //     'event',
      //     `Passenger_${field}`,
      //     {
      //       value: this.paxForm[type][n][`${field}${n}`],
      //       type: type,
      //       order: n + 1
      //     }
      //   )
      // }
      this.highlightCheck()
    },
    highlightCheck () {
      let self = this
      let fields = [
        'title', 'firstName', 'lastName',
        'gender', 'email', 'address',
        'city', 'zip',
        'country', 'mobile',
        'birthMonth', 'birthDay',
        'birthYear'
      ]

      let hasSelected = false
      self.highlight.active = ''
      self.paxForm.adult.forEach((pax, i) => {
        if (hasSelected) return

        fields.forEach(field => {
          if (hasSelected ||
            (field === 'email' && i !== 0) ||
            (field === 'mobile' && i !== 0)
          ) return
          if (!pax[`${field}${i}`]) {
            hasSelected = true
            self.highlight.active = `adult-${field}${i}`
          }
        })
      })

      if (hasSelected) return

      self.paxForm.children.forEach((pax, i) => {
        if (hasSelected) return

        fields.forEach(field => {
          if (hasSelected ||
            (field === 'email' && i === 0 && self.paxForm.adult.length) ||
            (field === 'email' && i !== 0) ||
            (field === 'mobile' && i === 0 && self.paxForm.adult.length) ||
            (field === 'mobile' && i !== 0)
          ) return
          if (!pax[`${field}${i}`]) {
            hasSelected = true
            self.highlight.active = `children-${field}${i}`
          }
        })
      })

      if (hasSelected) return

      self.paxForm.infants.forEach((pax, i) => {
        if (hasSelected) return

        fields.forEach(field => {
          if (hasSelected ||
            (field === 'email' && i === 0 && (self.paxForm.adult.length || self.paxForm.children.length)) ||
            (field === 'email' && i !== 0) ||
            (field === 'mobile' && i !== 0) ||
            (field === 'mobile' && i === 0 && (self.paxForm.adult.length || self.paxForm.children.length))
          ) return
          if (!pax[`${field}${i}`]) {
            hasSelected = true
            self.highlight.active = `infants-${field}${i}`
          }
        })
      })
    },
    bookAsGuest () {
      this.$store.commit('booking/setOthersData', {bookAsGuest: true})
      this.renderPax = true
    },
    paxMobileVerified (val) {
      this.paxFormMobileVerified = val
      this.isVerified = true
    },
    setGuestToken () {
      let self = this
      let travellers = self.filters.travellers
      let firstPax = travellers.info.adult[0] || {}
      if (!travellers.info.adult.length && travellers.info.children.length) firstPax = travellers.info.children[0]
      else if (!travellers.info.adult.length && travellers.info.infants.length) firstPax = travellers.info.infants[0]

      let bday = ''
      if (firstPax.birthDay0 && firstPax.birthMonth0 && firstPax.birthYear0) {
        bday = moment(`${firstPax.birthYear0}-${firstPax.birthMonth0}-${firstPax.birthDay0}`, 'YYYY-MM-DD').format('YYYY-MM-DD')
      }

      let newUserToken = this.session.generateGuestToken()
      let phone = `+${firstPax.countryCode0}${firstPax.mobile0}`
      let gender = firstPax.gender0
      if ([1, '1'].indexOf(firstPax.gender0) > -1) gender = 'Male'
      if ([2, '2'].indexOf(firstPax.gender0) > -1) gender = 'Female'
      self.$sdk.post(self, '/auth/guest', {
        device: newUserToken,
        email: firstPax.email0,
        firstName: firstPax.firstName0,
        lastName: firstPax.lastName0,
        paxinfo: {
          title: firstPax.title0,
          gender: gender
        },
        phone: phone,
        wheelchair: false,
        serviceDog: false,
        dateOfBirth: bday,
        brandID: self.$store.state.brandId,
        deviceType: 'web',
        countryCode: firstPax.countryCode0,
        nationalNumber: firstPax.mobile0,
        passportNum: firstPax.passport0,
        userCountry: firstPax.country0,
        d2d: 1
      }, res => {
        if (res.message) {
          let msg = res.message
          if (msg === 'backend.E_D2D_EXIST') msg = 'An account with this email already exists. Please log in to continue your booking or use a different email.'
          self.$store.commit('global/setAlertData', {show: true, message: msg})
          return
        }
        if (res.error) {
          let msg = res.error.message
          if (msg === 'backend.E_D2D_EXIST') msg = 'An account with this email already exists. Please log in to continue your booking or use a different email.'
          self.$store.commit('global/setAlertData', {show: true, message: msg})
          return
        }

        self.session.useToken(newUserToken) // Only save the token if successful
        self.$store.commit('user/setToken', newUserToken)
        res.token = newUserToken
        res.address = firstPax.address0
        res.zip = firstPax.zip0
        res.city = firstPax.city0
        self.saveAddress(res, true)
        self.$emit('done', true)
      }, '/1.1')
    },
    guestLogin () {
      this.$store.commit('booking/setOthersData', {bookAsGuest: false})
      // this.renderPax = false
    },
    changeDate (val, type, i) {
      let date = new Date(val)
      date = moment(date)
      this.paxForm[type][i][`birthMonth${i}`] = date.format('MM')
      this.paxForm[type][i][`birthDay${i}`] = date.format('DD')
      this.paxForm[type][i][`birthYear${i}`] = date.format('YYYY')
      this.highlightCheck()
    },
    setCountryDefault () {
      let self = this
      let countryCode = 1
      let find = self.countryList.find(x => x.code === self.booking.defaultCountry.toLowerCase())
      if (find) countryCode = find.dialCode

      let travInfo = this.filters.travellers.info
      travInfo.adult.forEach((adult, i) => {
        adult[`country${i}`] = self.booking.defaultCountry
        adult[`countryCode${i}`] = countryCode
      })
      travInfo.children.forEach((children, i) => {
        children[`country${i}`] = self.booking.defaultCountry
        children[`countryCode${i}`] = countryCode
      })
      travInfo.infants.forEach((infants, i) => {
        infants[`country${i}`] = self.booking.defaultCountry
        infants[`countryCode${i}`] = countryCode
      })
    },
    loginUser (r) {
      console.log('loginUser', r)
      this.loginSuccess(r, r.token)
    },
    nonUser (r) {
      this.bookAsGuest()
      console.log('nonUser', r)
      this.isMobileVerified = false
      if (r.loginVia === 'email') this.paxForm.adult[0].email0 = r.email
      else {
        this.isMobileVerified = true
        this.paxForm.adult[0].mobile0 = r.phone
        this.paxForm.adult[0].countryCode0 = r.countryCode
      }
    },
    getUserInfo (r) {
      console.log('getUserInfo', r)
    },
    hideVeriForm () {
      console.log('hideVeriForm')
    }
  },
  watch: {
    _token (val) {
      this.showAuthBox = val === '' || val === null
    },
    bookingAsGuest (val) {
      this.forSomeoneElse = false
    },
    'logoutStore.success': function (val) {
      if (val) {
        let self = this
        self.$store.commit('global/setLogoutData', {success: false})
        this.$store.commit('user/setIsCorporate', false)
        if (this.$refs.userMobile && this.$refs.userMobile.changePhoneNumber()) {
          this.$refs.userMobile.changePhoneNumber()
        }
        self.setCountryDefault()
      }
    },
    _reviewAction (val) {
      if (val === 'signup') {
        this.initShowSignup()
        this.$store.commit('booking/setOthersData', {reviewAction: ''})
        return
      }
      if (val === 'signupCorpSuccess') {
        this.initShowSignup()
        this.$store.commit('booking/setOthersData', {reviewAction: ''})
        return
      }
    }
  },
  mounted () {
    let self = this
    if (
      (!Object.keys(this.locations.pickupAirport).length && this.other.widgetTab === 'd2d') ||
      (this.locations.flight.pickup.title === '' && this.other.widgetTab === 'flight')
    ) {
      this.$root.$router.push('search')
      return
    }
    this.session = new WidgetSession(this)
    this.showAuthBox = !this._token
    if (!this._token) {
      this.$store.commit('booking/setOthersData', {bookAsGuest: true})
      self.setCountryDefault()
    } else {
      this.toggleForSomeone()
    }

    this.paxForm = this.filters.travellers.info
    this.highlightCheck()

    let firstVisit = localStorage.getItem('firstVisitData')
    if (firstVisit) {
      firstVisit = JSON.parse(firstVisit)
      if (firstVisit.mobile) this.mobile = firstVisit.mobile
      if (firstVisit.countryCode) this.countryCode = firstVisit.countryCode
      if (firstVisit.mobile && firstVisit.countryCode) this.isVerified = true
    }
  }
}
</script>

<style lang="scss" scoped>
.pax-box{
  border: 1px solid #abb2b8;
  border-radius: 6px;
  padding: 25px 20px;
  background: #fff;
  position: relative;
  margin-bottom: 30px;
}
.pax-head{
  margin-bottom: 10px;
}
.page-title{
  font-size: 21px;
  font-weight: 600;
  letter-spacing: .5px;

  span{
    letter-spacing: .6px;
    font-size: 16px;
    font-weight: 500;
    display: inline-block;
    margin-left: 15px;
    vertical-align: 2px;
    color: #7a7a7a;
  }
}
.logout-box{
  a{
    color: #ff9c09;
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;
    margin: 0 10px;

    &:first-child{
      margin-left: 0;
    }
    &:last-child{
      margin-right: 0;
    }
  }
}
.pax-copy{
  color: #5E6E7F;
  margin-bottom: 20px;
  letter-spacing: .4px;
}

.pax-form{
  padding: 10px 0;
  position: relative;
  margin-bottom: 10px;

  .row{
    .columns{
      margin-bottom: 10px;
    }
  }
  &.need-auth{
    filter: blur(2px);

    .blocker{
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
    }
  }
  .require-txt{
    font-size: 12px;
    letter-spacing: .6px;
    color: #787878;
    font-weight: 500;
    text-transform: none;
  }
}
.pax-id{
  margin-bottom: 15px;
  b{
    font-size: 16px;
    margin-right: 10px;
  }
}
.pax-basic-info{
  display: flex;
  flex-wrap: wrap;
  gap :10px;
  margin-bottom: 20px;

  .pax-field{
    margin-bottom: 0;
  }
}
.pax-field-label{
  color:#5E6E7F;
  font-size: 13px;
  letter-spacing: .5px;

  span{
    font-weight: 600;
    color: #f00;
  }
  &.label-up{
    font-size: 14px;
    font-weight: 600;
  }
}
.multi-fields{
  gap: 10px;
  .pax-field{
    width: 100%;
  }
}
.pax-title{
  max-width: 100px;
  padding: 10px;
  line-height: 1;
  border: 1px solid #ccc;

  &.has-error{
    border: 1px solid #EB5837;
  }
}
.rv-addrss{
  display: flex;
  gap: 10px;
}
.pax-bday{
  padding: 10px;
  line-height: 1;
  border: 1px solid #ccc;

  &.has-error{
    border: 1px solid #EB5837;
  }
}
.for-someone{
  display: inline-block;
  margin-left: 10px;

  input{
    width: auto!important;
    vertical-align: -1px;
    margin-right: 3px;
  }
  *{
    cursor: pointer;
  }
}
.no-outline{
  outline: none;

  &.active,
  &:hover{
    outline: 1px solid #ff9c09;
  }
}

.country-selector{
  padding: 10px;
  line-height: 1;
  border: 1px solid #ccc;

  &.has-error{
    border:1px solid #EB5837;
  }
}
.submit-pax-box{
  margin-bottom: 30px;
}
.pax-split{
  border: none;
  border-top: 1px dashed #ddd;
  margin: 30px 0;
}

.auth-wrap{
  position: absolute;
  top: 50px;
  left: 0;
  width: 100%;
}
.auth-box{
  width: calc(100% - 50px);
  max-width: 500px;
  border: 1px solid #ccc;
  background: #f9f9f9;
  padding: 20px;
  box-shadow: 1px 1px 3px rgba(0,0,0,.1);
  text-align: center;

  .page-title{
    padding: 0;
    margin-bottom: 20px;
  }
}

.pax-field{
  margin-bottom: 10px;

  input{
    padding: 10px;
    line-height: 1;
    box-shadow: inset 1px 1px 2px rgba(0,0,0,.1);
    border: 1px solid #ccc;
    width: 100%;
  }
  &.has-error{
    input,
    select{
      border:1px solid #EB5837;
    }
  }
}
.forgot-box{
  text-align: left;
  color: #777;
  text-decoration: underline;

  span{
    cursor: pointer;
  }
}
.login-btn{
  margin: 20px 0;
}
.no-account{
  text-align: center;

  a{
    color: #ff9c09!important;
    font-weight: 600;
    cursor: pointer;
  }
}
.as-guest{
  color: #ff9c09 !important;
  margin: 10px 0;
  display: inline-block;
  font-style: italic;
  text-decoration: underline;
  letter-spacing: .6px;
}
.error-msg{
  border: 1px solid #f00;
  background: #fadfdf;
  color: #f00;
  padding: 5px;
  line-height: 1.3;
  border-radius: 2px;
  margin: 20px 0;
  text-align: left;

  a{
    color: #285cc7;
    font-weight: 600;
  }
}
.require-txt{
  font-weight: 600;
  font-size: 11px;
  color: #417384;
  letter-spacing: .6px;
  text-transform: uppercase;
}
.signup-btn{
  margin: 20px 0;
}

@media only screen and (max-width: 40em) {
  .pax-form {
    .row .large-6 {
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// PaxForm.vue?1e057d1d